import { isSsr } from './general';
export const getAuthorizationToken = () => { var _a, _b; return !isSsr ? ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.token) || '' : ''; };
export const isLoggedIn = () => { var _a, _b; return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.isLoggedIn) || false; };
export const isB2BUser = () => { var _a, _b; return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.isB2BCustomer) || false; };
export const sortUsers = (users) => {
    // Sorting users by last name
    return users.slice().sort((first, second) => {
        const aLastName = (first.lastName || '').toLowerCase();
        const bLastName = (second.lastName || '').toLowerCase();
        return aLastName.localeCompare(bLastName);
    });
};
